package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.link
import com.varabyte.kobweb.silk.style.selectors.visited
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px

// Masqué sur Desktop, affiché sur Mobile
val FooterMobileSectionStyle = CssStyle {
    base { Modifier.display(DisplayStyle.Flex) }
    Breakpoint.MD { Modifier.display(DisplayStyle.None) }
}

// Masqué sur Mobile, affiché sur Desktop
val FooterDesktopSectionStyle = CssStyle {
    base { Modifier.display(DisplayStyle.None) }
    Breakpoint.MD { Modifier.display(DisplayStyle.Flex) }
}

val FooterMainContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(leftRight = 20.px)
    }
    Breakpoint.MD {
        Modifier
            .maxWidth(1200.px)
            .padding(leftRight = 40.px)
    }
}

val FooterBrandContainerStyle = CssStyle {
    base { Modifier.width(300.px) }
}

val FooterBrandLogoStyle = CssStyle {
    base { Modifier.width(40.px).height(25.px) }
    Breakpoint.MD { Modifier.width(60.px).height(40.px) }
}

val FooterBrandTextStyle = CssStyle {
    base {
        Modifier
            .fontFamily(INTER)
            .fontWeight(FontWeight.Normal)
            .whiteSpace(WhiteSpace.PreWrap)
            .fontSize(13.px)
            .styleModifier { property("text-align", "start") }
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

val FooterLinkColumnStyle = CssStyle {
    base {
        Modifier
            .whiteSpace(WhiteSpace.PreWrap)
            .gap(12.px)
    }
    Breakpoint.MD {
        Modifier.gap(15.px)
    }
}

//val NavigationLinkStyle = CssStyle {
//    base {
//        Modifier
//            .fontFamily(INTER)
//            .fontSize(13.px)
//            .textDecorationLine(TextDecorationLine.None)
//    }
//
//    // Force la suppression sur absolument tous les états CSS possibles générés par Silk/navigateur
//    link { Modifier.textDecorationLine(TextDecorationLine.None) }
//    visited { Modifier.textDecorationLine(TextDecorationLine.None) }
//    hover { Modifier.textDecorationLine(TextDecorationLine.None) }
//    focus { Modifier.textDecorationLine(TextDecorationLine.None) }
//    active { Modifier.textDecorationLine(TextDecorationLine.None) }
//
//    Breakpoint.MD {
//        Modifier.fontSize(18.px)
//    }
//}

val FooterDividerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(300.px)
            .height(1.px)
            .margin(top = 25.px, bottom = 15.px)
    }
    Breakpoint.MD {
        Modifier.maxWidth(1300.px)
    }
}

val FooterCopyrightStyle = CssStyle {
    base {
        Modifier
            .fontFamily(INTER)
            .padding(top = 5.px, bottom = 10.px)
            .textAlign(TextAlign.Center)
            .fontSize(13.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
}